import { render } from "./finishPage.vue?vue&type=template&id=513ec40f&scoped=true"
import script from "./finishPage.vue?vue&type=script&lang=js"
export * from "./finishPage.vue?vue&type=script&lang=js"

import "./finishPage.vue?vue&type=style&index=0&id=513ec40f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/adQuestionsPop/finishPage.vue'],['render',render],['__scopeId',"data-v-513ec40f"],['__file',"finishPage.vue"]])

export default __exports__